<p-card class="flex justify-center">
  @if (loading) {
    <div class="flex justify-center">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    </div>
  } @else {
    <form [formGroup]="accountForm" (ngSubmit)="submitForm()" novalidate>
      <p-tabs value="0">
        <p-tablist>
            <p-tab value="0">General</p-tab>
            <p-tab value="1">Settings</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
            <div class="field flex flex-col gap-2">
              <label for="company" class="block" i18n="edit account form|Form label">Company</label>
              <input type="text" pInputText formControlName="company" />
              @if (accountForm.get('company')?.invalid && accountForm.get('company')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('company')?.hasError('required')) {
                    <ng-container i18n="edit account form|Company required error">Company is required.</ng-container>
                  }
                  @if(accountForm.get('company')?.hasError('pattern')) {
                    <ng-container i18n="edit account form|Company pattern error">Company must not start with a digit.</ng-container>
                  }
                </p-message>
              }
            </div>

            <div class="field flex flex-col gap-2">
              <label for="field street" class="block" i18n="edit account form|Form label">Street</label>
              <input type="text" pInputText formControlName="street" />
              @if (accountForm.get('street')?.invalid && accountForm.get('street')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('street')?.hasError('required')) {
                    <ng-container i18n="edit account form|Street required error">Street is required.</ng-container>
                  }
                  @if(accountForm.get('street')?.hasError('pattern')) {
                    <ng-container i18n="edit account form|Street pattern error">Street must not start with a digit.</ng-container>
                  }
                </p-message>
              }
            </div>

            <div class="field flex flex-col gap-2">
              <label for="city" class="block" i18n="edit account form|Form label">City</label>
              <input type="text" pInputText formControlName="city" />
              @if (accountForm.get('city')?.invalid && accountForm.get('city')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('city')?.hasError('required')) {
                    <ng-container i18n="edit account form|City is required error">City is required.</ng-container>
                  }
                </p-message>
              }
            </div>

            <div class="field flex flex-col gap-2">
              <label for="zip" class="block" i18n="edit account form|Form label">Zip</label>
              <input type="text" pInputText formControlName="zip" />
              @if (accountForm.get('zip')?.invalid && accountForm.get('zip')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('zip')?.hasError('required')) {
                    <ng-container i18n="edit account form|Zip is required error">Zip is required.</ng-container>
                  }
                </p-message>
              }
            </div>

            <div class="field flex flex-col gap-2">
              <label for="country" class="block" i18n="edit account form|Form label">Country</label>
              <app-country-selector formControlName="country"></app-country-selector>
            </div>

            <div class="field flex flex-col gap-2">
              <label for="countryState" class="block" i18n="edit account form|Form label">Country State/Province</label>
              <app-country-state-selector formControlName="countryStateComposite" [country]="accountForm.get('country')?.value"></app-country-state-selector>
            </div>

            <div class="field flex flex-col gap-2">
              <label for="phone" class="block" i18n="edit account form|Form label">Phone</label>
              <input type="text" pInputText formControlName="phone" />
              @if (accountForm.get('phone')?.invalid && accountForm.get('phone')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('phone')?.hasError('required')) {
                    <ng-container i18n="edit account form|Phone is required error">Phone is required.</ng-container>
                  }
                  @if (accountForm.get('phone')?.hasError('pattern')) {
                    <ng-container i18n="edit account form|Phone format error">Telephone Number must be in the format +[country code].[number], e.g. +1.123456789</ng-container>
                  }
                </p-message>
              }
            </div>

            <div class="field flex flex-col gap-2">
              <label for="fax" class="block" i18n="edit account form|Form label">Fax</label>
              <input type="text" pInputText formControlName="fax" />
              @if (accountForm.get('fax')?.invalid && accountForm.get('fax')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('fax')?.hasError('required')) {
                    <ng-container i18n="edit account form|Fax is required error">Fax is required.</ng-container>
                  }
                </p-message>
              }
            </div>

          </p-tabpanel>
          <p-tabpanel value="1">
            <div class="field flex flex-col gap-2">
              <label for="passwordTtl" class="block" i18n="edit account form|Form label">Pasword TTL</label>
              <input type="number" pInputText formControlName="passwordTtl" aria-describedby="password-ttl-help" />
              <small id="password-ttl-help">The TTL is in number of months.</small>
              @if (accountForm.get('passwordTtl')?.invalid && accountForm.get('passwordTtl')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('passwordTtl')?.hasError('min')) {
                    <ng-container i18n="edit account form|Password TTL must be at least 1 month">Password TTL must be at least 1 month.</ng-container>
                  }
                  @if (accountForm.get('passwordTtl')?.hasError('max')) {
                    <ng-container i18n="edit account form|Password TTL must be at most 12 months">Password TTL must be at most 12 months.</ng-container>
                  }
                </p-message>
              }
            </div>
            <div class="field flex flex-col gap-2">
              <label for="passwordMinLength" class="block" i18n="edit account form|Form label">Password Minimum Length</label>
              <input type="number" pInputText formControlName="passwordMinLength" />
              @if (accountForm.get('passwordMinLength')?.invalid && accountForm.get('passwordMinLength')?.dirty) {
                <p-message severity="error" size="small" variant="simple">
                  @if (accountForm.get('passwordMinLength')?.hasError('min')) {
                    <ng-container i18n="edit account form|Password minimum length must be at least 12 characters">The password minimum length must be at least 12 characters.</ng-container>
                  }
                  @if (accountForm.get('passwordMinLength')?.hasError('max')) {
                    <ng-container i18n="edit account form|Password minimum length must be at most 128 characters">The password minimum length must be at most 128 characters.</ng-container>
                  }
                </p-message>
              }
            </div>
            <div class="field">
              <p-checkbox inputId="forceOriginalPassword" formControlName="forceOriginalPassword" binary="true" i18n-label="edit account form|Form label" />
              <label for="forceOriginalPassword" class="ml-2" i18n="edit account form|Form label">Force Original Password</label>
              <small id="force-original-password-help" class="block">When enabled, users cannot set a password that they have used before.</small>
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
      <button
        pButton
        type="submit"
        label="Update Account"
        [disabled]="accountForm.invalid || !accountForm.dirty || loading"
        i18n-label="edit-account|Submit button">
      </button>
    </form>
  }
</p-card>